import { Component, Injector } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Mj_Detail } from '../mj_detail/mj_detail';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { HatComponent } from '../component/hat';
import { LancetsComponent } from '../component/lancets';
import { LineSvgComponent } from '../component/linesvg';
import { UserStarComponent } from '../component/userstar';
import { Confirm } from '../confirm/confirm';
import { Profilo } from '../profilo/profilo';
import { Impostazioni } from '../impostazioni/impostazioni';
import { BadgePage } from '../badge/badge';
import { Dashboard } from '../dashboard/dashboard';
import { Global_Statistiche } from '../global_statistiche/global_statistiche';
import { ClassifichePage } from '../classifiche/classifiche';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmLogout } from '../confirmLogout/confirmLogout';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
/*@NgModule({
  imports: [RoundProgressModule]
})*/
@Component({
  selector: 'page-menu',
  templateUrl: 'menu.html',
})
export class Menu extends Util {
  pagine: any;
  user: any;
  mjl: any;
  page: string;
  getbg = { allena: {}, apprendi: {}, competenze: {}, shop: {} };
  percent_hat = '20%';
  statistiche: any;
  constructor(public navCtrl: NavController, public translate: TranslateService, public navParams: NavParams, injector: Injector, loading: LoadingController, hat: HatComponent, lancets: LancetsComponent, linesvg: LineSvgComponent, userstar: UserStarComponent) {
    super(injector, loading);
    this.user = this.navParams.get('user');
    this.statistiche = this.navParams.get('statistiche');
    this.page = 'dash';
    this.refreshpage();
  }
  refreshpage() {
    this.GetRequest('microjourneyListNew', '').then(data => {

      //this.mjl = data['MicroJourneyList']['da_iniziare'];
      this.mjl = data['MicroJourneyList'];
      //console.log(this.mjl);
    }).catch((e) => {
      //this.navCtrl.push(Mj_Detail,{mj:m});
      console.error(e)
    })
  }
  // mjl_detail(m) {
  //   if (m.stato == 'da_iniziare') {
  //     this.presentPopover(event, Confirm, 'Sei sicuro di voler attivare il Percorso ' + m.nome + '?').then((data) => {
  //       //console.log(data);
  //       if (data == 'confirm') {
  //         this.PostRequest('attivaMJ', m.id, {}, true, true).then((res) => {
  //           //console.log(res);
  //           //TO DO controllo che è andato sullo stato creato
  //           this.navCtrl.push(Mj_Detail,{mj:m});

  //         }).catch((e) => {
  //           //this.navCtrl.push(Mj_Detail,{mj:m});
  //           console.error(e)
  //         })
  //       }
  //     })
  //   }
  //   else
  //     this.navCtrl.push(Mj_Detail,{mj:m});
  //   //Open Popup p

  // }
  open_menu() {
    //console.log('open menu');
  }
  open_page(page) {

    switch (page) {
      case 'profilo':
        this.navCtrl.push(Profilo);
        break;
      case 'impostazioni':
        this.navCtrl.push(Impostazioni);
        break;
      case 'badge':
        this.navCtrl.push(BadgePage);
        break;
      case 'statistiche':
        this.navCtrl.push(Global_Statistiche, { statistiche: this.statistiche });
        break;
      case 'classifiche':
        this.navCtrl.push(ClassifichePage, { user: this.user });
        break;
    }

  }
  doSomethingWithCurrentValue(ev) {
    //console.log(ev);
  }
  openconfirm(event) {
    this.presentPopover(event, Confirm, 'vuoi confermare?').then((data) => {
      //console.log(data);
    })
  }

  logout_yamapp(){
    this.presentPopover(event, ConfirmLogout, 'Vuoi tornare al portale Yamacademy o vuoi uscire da YamApp?').then((data) => {
      
      if(data == 'confirm'){
        
        window.location.href = 'https://learning.yamacademy.it/';
      }
      else if(data == 'exit'){
        //ESCI DA YAMAPP
        this.logout();
      }
    })
  }

  logout() {

    this.storage.get('user').then(user => {
      this.storage.get('tokenFCM').then((tokenfcm) => {
        if (tokenfcm != '' && tokenfcm != undefined && tokenfcm != null) {
          if (this.etheme.theme_selected == 'mygame-theme' ) {
            this.PostRequest('remove_device', '', { 'cliente': 'mygame', 'device': 'Android', 'tokenFCM': tokenfcm }, false, false).then((r) => {
          
            })
          }
          else if (this.etheme.theme_selected == 'dark-theme_' ) {
            this.PostRequest('remove_device', '', { 'cliente': 'eydlab', 'device': 'Android', 'tokenFCM': tokenfcm}, false, false).then((r) => {
           
            })
          }
          else if (this.etheme.theme_selected == 'yamamay-theme') {
            this.PostRequest('remove_device', '', { 'cliente': 'yamamay', 'device': 'Android', 'tokenFCM': tokenfcm}, false, false).then((r) => {
             
            })
          }
          else if (this.etheme.theme_selected == 'carrefour-theme' ) {
            this.PostRequest('remove_device', '', { 'cliente': 'carrefour', 'device': 'Android', 'tokenFCM': tokenfcm}, false, false).then((r) => {
        
            })
          }
          else if (this.etheme.theme_selected == 'noeinglese-theme' ) {
            this.PostRequest('remove_device', '', { 'cliente': 'noeformazione', 'device': 'Android', 'tokenFCM': tokenfcm}, false, false).then((r) => {
        
            })
          }
        }
      })
      if (user != undefined) {
        let webkit = (window as any).webkit;
        if (webkit != undefined) {
          webkit.messageHandlers.jsHandler.postMessage(JSON.stringify({
            method: "remove_device",
            data: {
              token: user.token,
              url: this.urlserver
            }
          }));
        }
      }

      this.cleardata();
    },
      error => {
        this.cleardata();
      });


  }

  cleardata() {
    this.storage.get('language').then((lan) => {
      var language = lan;
      this.storage.remove('user').then(() => {
        // this.storage.clear();
        this.storage.set('language', language).then((lan) => {
          if (this.etheme.theme_selected == 'sky-theme' || this.etheme.theme_selected == 'yamamay-theme' || this.etheme.theme_selected == 'carrefour-theme') {
            let url = document.URL;
            window.location.href = url.replace('?login=sso', '');
          }
          else
            window.location.reload();
          // window.location.reload();
        })
      });
    })

  }


  back() {
    this.navCtrl.pop({ animate: false });
  }
  go_root() {
    this.navCtrl.setRoot(Dashboard);
  }
}



// WEBPACK FOOTER //
// ./src/pages/menu/menu.ts